import TutorDetailGoals from './TutorDetailGoals';

export default TutorDetailGoals;
